import { Flatfile } from "@flatfile/api";

export const spaceConfig: Flatfile.SpaceConfig = {
  name: "Add or edit members",
  metadata: {
    sidebarConfig: {
      showSidebar: false,
    },
    theme: {
      root: {
        primaryColor: "#0458E5",
        textColor: "white",
      },
    },
  },
};
